import React from "react";

const CancelPage: React.FC = () => {
  return (
    <div style={{ textAlign: "center", padding: "2rem" }}>
      <h2>Payment Not Completed</h2>
      <p>It looks like your payment was cancelled or did not go through.</p>
      <p>If you’d like to retry, return to your preferences and regenerate your blog.</p>
      <button onClick={() => window.location.href = "/"}>Go Back</button>
    </div>
  );
};

export default CancelPage;